<template>
  <div class="tooltip" :class="[placement]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    placement: { type: String, default: '', required: false },
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  display: none;
  position: absolute;
  bottom: 120%;
  background: rgba(0, 12, 31, 0.8);
  // border: 1px solid var(--main-dark);
  border-radius: 10px;
  font-size: 12px;
  line-height: 20px;
  color: var(--main-light);
  font-weight: normal;
  left: 50%;
  width: 180px;
  padding: var(--spacing-12);
  transform: translateX(-50%);
  white-space: normal;
  z-index: 1;
  text-align: center;

  &:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid rgba(0, 12, 31, 0.8);
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -3px;
  }

  &.bottom {
    bottom: auto;
    top: 120%;

    &:after {
      top: auto;
      bottom: 100%;
      border-top: none;
      border-bottom: 5px solid rgba(0, 12, 31, 0.8);
    }
  }
}
</style>
